import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { replaceLocationBasedTerms } from '@/utils/replaceLocationBasedTerms';
import { ReactNode } from 'react';
import { useShallow } from 'zustand/react/shallow';

export default function MemberInformationContainer({ children }: { children: ReactNode }) {
  const { locationId } = usePrenuvoStore(
    useShallow((state) => ({
      locationId: state.scan.locationId,
    })),
  );

  return (
    <>
      <h2 className="section-title">{replaceLocationBasedTerms('Patient Details', locationId)}</h2>
      <p>
        {replaceLocationBasedTerms(
          'Please enter the following details for the person that will be getting scanned',
          locationId,
        )}
        .
      </p>
      <div className="my-5">{children}</div>
    </>
  );
}
